import {createRootRoute} from '@tanstack/react-router';
import {AppRoot} from 'pages/AppRoot';

export const Route = createRootRoute({
  component: AppRoot,
});
